import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@angular/cdk/layout';
import { RouteResolver } from './core/route-resolver.service';
import { RedirectGuard } from './core/redirect.guard';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MainPipe } from './common/mainpipe.module';
import {MatSliderModule} from '@angular/material/slider';
import { AktifButtonModule } from './ui/atoms/button/aktif-button.module';
import { PageModule } from './ui/pages/home/page.module';
import { NgxMaskModule } from 'ngx-mask';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { IframePageComponent } from './ui/organisms/iframe-page/iframe-page.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
@NgModule({
  declarations: [
    AppComponent,
    IframePageComponent,
    SafeUrlPipe,
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'AktifBank'}),
    AppRoutingModule,
    HttpClientModule,
    BrowserTransferStateModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    LayoutModule,
    MainPipe,
    AktifButtonModule,
    MatSliderModule,
    PageModule,
    SwiperModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [
    RouteResolver,
    RedirectGuard,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
